import { cardContainerStyles } from "@insite/content-library/Components/CardContainer";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

/**
 * ChangeLog:
 * 2024-01-31: DD: Adding @media print { display: none !important; }
 *  This is to ensure the existing card does not print.
 */

cardContainerStyles.cardDivider = {
    css: css`
        width: 100%;
        @media print {
            display: none !important;
        }
    `,
};

cardContainerStyles.gridItem = {
    width: 12,
    css: css`
        border-bottom: 1px solid ${getColor("common.border")};
    `,
};
